import make, { Enum } from '@xaamin/enum';

class PacStatus extends Enum {

  name = 'PacStatus';

  enum = {
    'active': 1,
    'inactive': 0,
    'sandbox': 2,
    'round-robin': 3,
    'blocked': 4,
    'manual': 5,
    'undefined': 33,
  }

  isActive() {
    return this.getValue() === 1 || this.getValue() === 5;
  }
}

export default make(PacStatus);